import React from "react";
import AboutConclave from "./AboutConclave";
import AttendeesSection from "./AttendeesSection";
import BannerConclave from "./BannerConclave";
import HeroSectionConclave from "./HeroSectionConclave";
import StepSection from "./StepSection";
import ConclaveFooter from "./ConclaveFooter";

function Conclave(props) {
  return (
    <>
      <HeroSectionConclave />
      <AboutConclave />
      <BannerConclave />
      <StepSection />
      <AttendeesSection />
      <ConclaveFooter />
    </>
  );
}

export default Conclave;
